<kendo-dialog title="Change Organization" class="app-dialog" (close)="close()" [minWidth]="250" [maxWidth]="404" id="changeOrgDialog">
  <div *ngIf="!dataLoading" class="nova-font-style">
    <div *ngIf="message">
      {{message}}
    </div>
    <div *ngIf="!message">
      <label class="bold">Organization: </label>
      <kendo-dropdownlist id="ddlOrgSelect" [data]="data" [textField]="'orgName'" [valueField]="'orgId'"
        [(ngModel)]="defaultOrg" (selectionChange)="selectionChange($event)"
        [popupSettings]="{ popupClass: 'nova-font-style text-black' }">
      </kendo-dropdownlist>
    </div>
  </div>
  <div *ngIf="dataLoading" class="k-i-loading inner"></div>
  <kendo-dialog-actions>
    <button id="btnOrgSelectClose" kendoButton (click)="close()"> {{message ? 'OK' : 'Close'}}</button>
  </kendo-dialog-actions>
</kendo-dialog>
